export const SECONDS_IN_DAY = 86400;
